import { Component } from "javascripts/lib/component";
import { Listable } from "javascripts/lib/store/concerns/listable";

export class ProductList extends Listable(Component) {
  init() {
    this.page = this.options.page;

    this.actsAsList({
      features: {
        textToggling: true
      }
    });
  }
}
